import { useEffect, useState } from "react";
import axios from "../../../lib/axios";
import {
  MERCHANT_STORE_FIND_ONE,
  MERCHANT_STORE_UPDATE,
} from "../../../lib/endpoints/merchants";
import { MerchantUserModel } from "../../../models/merchantUser";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import moment from "moment";
import { OrderModel } from "../../../models/order";
import {
  ADMIN_ORDER_FIND_MANY,
  ORDER_ADMIN_SUMMARY,
} from "../../../lib/endpoints/order";
import { OrderStatusEnum } from "../../../enums/orderStatus";
import { convertOrderStatusEnumToStatusCode } from "../../../utils/convertOrderStatusValue";
import { PRODUCT_GET_COUNT_MERCHANT_PRODUCT } from "../../../lib/endpoints/product";
import { MAIN_GROUP_FIND_MANY } from "../../../lib/endpoints/category";
import { MerChantModel } from "../../../models/merChantModel";

interface ReportType {
  totalSale: number;
  completedSale: number;
  partiallyCompletedSale: number;
  returnSale: number;
  failedSale: number;
  customerOrder: number;
  toPackOrder: number;
  toShipOrder: number;
  shippingOrder: number;
}

interface ReturnOrderSummaryType {
  totalOrder: number;
  totalSale: number;
}

export const useHomeController = () => {
  // variables
  const authData: MerchantUserModel = useSelector(
    (state: RootState) => state?.auth?.data ?? null!
  );

  const [dataMerchantStore, setDataMerchantStore] = useState<MerChantModel>(
    null!
  );

  const [dataOrderReport, setDataOrderReport] = useState<ReportType>(null!);

  const [loading, setLoading] = useState<boolean>(true);
  const todayDate = moment(new Date()).format("DD/MM/yyyy");

  const [openMerchantStore, setOpenMerchantStore] = useState<boolean>(false);
  const [loadingMerchantStoreChange, setLoadingMerchantStoreChange] =
    useState<boolean>(false);

  const [countProductTotal, setCountProductTotal] = useState<number>(0);
  const [countCategoryTotal, setCountCategoryTotal] = useState<number>(0);

  // functions

  const handleGetMerchantStore = async () => {
    try {
      const getMerchantStore = await axios.get(
        MERCHANT_STORE_FIND_ONE + `?id=${authData?.merchantId}`
      );
      setDataMerchantStore(getMerchantStore?.data);
      if (getMerchantStore?.data?.isActive === true) {
        setOpenMerchantStore(true);
      } else {
        setOpenMerchantStore(false);
      }
    } catch (err) {}
  };

  const handleGetCountProductTotal = async () => {
    try {
      const res = await axios.post(
        PRODUCT_GET_COUNT_MERCHANT_PRODUCT +
          `?merchantId=${authData?.merchantId}`
      );
      setCountProductTotal(res?.data?.data?.All?._all);
    } catch (err) {}
  };

  const handleGetCountCategoryTotal = async () => {
    try {
      const res = await axios.post(MAIN_GROUP_FIND_MANY, {
        filter: {
          merchant_id: authData?.merchantId,
        },
      });
      setCountCategoryTotal(res?.data?.data?.length);
    } catch (err) {}
  };

  const handleGetDataOrderSummary = async (
    getStatusCode: OrderStatusEnum
  ): Promise<ReturnOrderSummaryType> => {
    try {
      const res = await axios.post(
        ORDER_ADMIN_SUMMARY +
          `?startDate=${moment(new Date()).format(
            "yyyy/MM/DD"
          )}&endDate=${moment(new Date()).format("yyyy/MM/DD")}${
            getStatusCode
              ? `&StatusCodeAdmin=${convertOrderStatusEnumToStatusCode(
                  getStatusCode
                )}`
              : ""
          }`,
        {
          merchantId: authData?.merchantId,
        }
      );
      return {
        totalOrder: res?.data?.totalOrder,
        totalSale: res?.data?.totalSale,
      };
    } catch (err) {
      console.log("err=", err);
      return {
        totalOrder: 0,
        totalSale: 0,
      };
    }
  };

  function filterDataByDate(
    data: OrderModel[],
    startDate: Date,
    endDate: Date
  ): OrderModel[] {
    return data.filter((item) => {
      const updatedAt = new Date(item.updatedAt).setHours(0, 0, 0, 0);
      return (
        updatedAt >= startDate.setHours(0, 0, 0, 0) &&
        updatedAt <= endDate.setHours(0, 0, 0, 0)
      );
    });
  }

  function calculateTotalWithDeliveryFeeSum(orders: OrderModel[]): number {
    return orders.reduce(
      (sum, order: OrderModel) => sum + order?.totoalWithDeliveryFee,
      0
    );
  }

  const handleGetDataOrder = async () => {
    try {
      // const getTotalSale: number = (await handleGetDataOrderSummary(null!))
      //   .totalSale;
      // const getCompletedSale: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Delivered)
      // ).totalSale;
      // const getPartillyCompletedSale: number = 0;
      // const getReturnSale: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Return)
      // ).totalSale;
      // const getFailedSale: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Failed)
      // ).totalSale;
      // const getCustomerOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Failed)
      // ).totalOrder;
      // const getToPackOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.To_Pack)
      // ).totalOrder;
      // const getToShipOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.To_Ship)
      // ).totalOrder;
      // const getShippingOrder: number = (
      //   await handleGetDataOrderSummary(OrderStatusEnum.Shipping)
      // ).totalOrder;
      const res = await axios.post(`${ADMIN_ORDER_FIND_MANY}`, {
        filter: {
          merchantId: authData?.merchantId,
        },
      });
      const newData: OrderModel[] = filterDataByDate(
        res?.data,
        new Date(),
        new Date()
      );
      setDataOrderReport({
        totalSale: calculateTotalWithDeliveryFeeSum(
          newData?.filter(
            (item) =>
              item?.status?.code ===
              convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)
          )
        ),
        completedSale: newData?.filter(
          (item) =>
            item?.status?.code ===
            convertOrderStatusEnumToStatusCode(OrderStatusEnum.Delivered)
        )?.length,
        partiallyCompletedSale: newData?.filter(
          (item) => item?.updateByAdmin === true
        )?.length,
        returnSale: newData?.filter(
          (item) =>
            item?.status?.code ===
            convertOrderStatusEnumToStatusCode(OrderStatusEnum.Return)
        )?.length,
        failedSale: newData?.filter(
          (item) =>
            item?.status?.code ===
            convertOrderStatusEnumToStatusCode(OrderStatusEnum.Failed)
        )?.length,
        customerOrder: newData?.filter(
          (item) =>
            item?.status?.code ===
            convertOrderStatusEnumToStatusCode(OrderStatusEnum.CURRENT_ORDER)
        )?.length,
        toPackOrder: newData?.filter(
          (item) =>
            item?.status?.code ===
            convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Pack)
        )?.length,
        toShipOrder: newData?.filter(
          (item) =>
            item?.status?.code ===
            convertOrderStatusEnumToStatusCode(OrderStatusEnum.To_Ship)
        )?.length,
        shippingOrder: newData?.filter(
          (item) =>
            item?.status?.code ===
            convertOrderStatusEnumToStatusCode(OrderStatusEnum.Shipping)
        )?.length,
      });
    } catch (err) {}
  };

  const handleGetData = async () => {
    try {
      await handleGetMerchantStore();
      await handleGetDataOrder();
      await handleGetCountProductTotal();
      await handleGetCountCategoryTotal();
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleMerchantStoreChange = async () => {
    try {
      setLoadingMerchantStoreChange(true);
      setOpenMerchantStore(!openMerchantStore);
      console.log(MERCHANT_STORE_UPDATE + `?id=${authData?.merchantId}`);
      console.log({
        isActive: !openMerchantStore,
      });
      await axios.patch(MERCHANT_STORE_UPDATE + `?id=${authData?.merchantId}`, {
        isActive: !openMerchantStore,
      });
    } catch (err) {
      window.alert("Server error please try again");
    } finally {
      setLoadingMerchantStoreChange(false);
    }
  };

  // useEffect
  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    openMerchantStore,
    loadingMerchantStoreChange,
    handleMerchantStoreChange,
    loading,
    todayDate,
    dataOrderReport,
    countProductTotal,
    countCategoryTotal,
    dataMerchantStore,
  };
};
